import SplitScore from './SplitScore.view';

export default SplitScore;
